<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">Links</h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Links</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <!-- <a
                  title="Show add link"
                  class="btn add-btn"
                  @click="showSearchFormAdd()"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_form"
                >
                  <i class="la la-plus"></i> Add Link
                </a>-->
                <div class="form-group form-focus">
                  <div class="btn-group btn-block">
                    <button
                      type="button"
                      class="btn btn-secondary btn-block"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span v-if="!isLoading">Export</span>
                      <span v-else>...</span>
                    </button>
                    <button
                      type="button"
                      class="btn btn-secondary dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="exportExcel('full')"
                        >Excel Full</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="exportExcel('mp')"
                        >Excel Marketplace</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="exportExcel('pdf')"
                        >PDF Marketplace</a
                      >
                    </div>
                  </div>
                </div>
                <!-- <div class="form-group form-focus">
                  <div class="btn-group btn-block">
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn btn-block"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span v-if="!isLoading">Add Link</span>
                      <span v-else>...</span>
                    </button>
                    <button
                      style="min-width: auto;"
                      type="button"
                      class="btn add-btn dropdown-toggle dropdown-toggle-split"
                      data-toggle="dropdown"
                      aria-haspopup="true"
                      aria-expanded="false"
                    >
                      <span class="sr-only">Toggle Dropdown</span>
                    </button>
                    <div class="dropdown-menu">
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="showSearchFormAdd()"
                        data-toggle="modal"
                        data-target="#add_form"
                        >Tambah</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="showSearchFormImport()"
                        data-toggle="modal"
                        data-target="#import_form"
                        >Import Excel</a
                      >
                      <a
                        class="dropdown-item"
                        :disabled="isLoading"
                        href="javascript:void(0)"
                        @click.prevent="showFormImportHtml()"
                        data-toggle="modal"
                        data-target="#import_form_html"
                        >Import HTML</a
                      >
                    </div>
                  </div>
                </div> -->
              </div>
            </div>
          </div>
          <!-- {{formParamSt}} -->
          <!-- /Page Header -->
          <!-- {{serverParams}} -->
          <!-- Search Filter -->
          <!-- {{selectAllTable}}-->
          <!-- {{selectedTable}} -->
          <div class="row filter-row" v-if="!selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <!-- <div class="cal-icon"> -->
                <input
                  v-model="serverParams.columnFilters.start_date"
                  class="form-control floating"
                  type="date"
                />
                <!-- </div> -->
                <label class="focus-label sr-only">From</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <div class="input-group">
                  <!-- <div class="cal-icon"> -->
                  <input
                    v-model="serverParams.columnFilters.end_date"
                    class="form-control floating"
                    type="date"
                  />
                  <!-- </div> -->
                  <div class="input-group-append">
                    <a
                      title="Show search options"
                      class="btn btn-primary"
                      @click="showSearchForm()"
                      href="#"
                      data-toggle="modal"
                      data-target="#search_form"
                    >
                      <i class="fa fa-list"></i>
                      <i
                        class="fa fa-circle"
                        v-if="formParamSt.more_search == true"
                      ></i>
                    </a>
                  </div>
                </div>

                <label class="focus-label sr-only">To</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <multiselect
                v-model="selectedContact"
                id="ajax"
                label="name"
                track-by="id"
                :placeholder="'Type to search Brand...'"
                :multiple="true"
                open-direction="bottom" 
                :options="contactOptions"
                :searchable="true"
                :loading="isLoading"
                :internal-search="false"
                :close-on-select="true"
                :options-limit="300"
                :limit="3" 
                :max-height="600" 
                :show-no-results="true"
                :hide-selected="false"
                @search-change="asyncFind" 
                :show-labels="false"
              >
                <template slot="tag" slot-scope="{ option, remove }">
                  <span class="custom__tag">
                    <span>{{ option.name }}</span>
                    <span class="custom__remove" @click="remove(option)"
                      >❌</span
                    >
                  </span>
                </template> 
                <span slot="noResult">Oops! No elements found.</span>
              </multiselect>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <a
                  href="javascript:void(0)"
                  @click.prevent="searchData"
                  class="btn btn-success btn-block"
                  >Search</a
                >
              </div>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <div class="btn-group">
                  <button
                    type="button"
                    class="btn btn-secondary"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    Actions
                  </button>
                  <button
                    type="button"
                    class="btn btn-secondary dropdown-toggle dropdown-toggle-split"
                    data-toggle="dropdown"
                    aria-haspopup="true"
                    aria-expanded="false"
                  >
                    <span class="sr-only">Toggle Dropdown</span>
                  </button>
                  <div class="dropdown-menu">
                    <!-- <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionEdit"
                      :data-toggle="selectedTable.length == 1 && 'modal'"
                      :data-target="selectedTable.length == 1 && '#edit_form'"
                    >Edit</a>-->
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionDelete"
                      >Delete</a
                    >
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionUpdateStatus('raw')"
                      >Raw</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionUpdateStatus('processing')"
                      >In Progress</a
                    >
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionUpdateStatus('closed')"
                      >Closed</a
                    >
                    <div class="dropdown-divider"></div>
                    <a
                      class="dropdown-item"
                      href="javascript:void(0)"
                      @click.prevent="actionBookmarks"
                      >Bookmark</a
                    >
                  </div>
                </div>

                <!-- <button class="btn btn-success btn-block">Scrape</button>
                <button class="btn btn-success btn-block">Excel</button>-->
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="scrapingDetailProduct"
                  class="btn btn-secondary btn-block"
                >
                  Cek Link
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-6">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <div
            v-if="linkExcel != '' && selectedTable.length == 0"
            class="col-md-12 alert alert-success"
          >
            If a popup block occurs, please download via this link:
            <a :href="linkExcel" target="_blank">Download Export</a>
          </div>
          <div class="row" v-if="isSrDetailId || isScheduleId || isKeywordId">
            <div class="col-md-12">
              <span class="badge badge-secondary">Filtered by Log</span>
              <a
                title="Clear Filter"
                :href="baseUrl + '/monitoring/links/list'"
                class="btn btn-xs"
              >
                <i class="fa fa-remove"></i>
              </a>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <!-- {{currentDateTimeUnix()}} -->
              <!-- {{sortBy}} // {{orderBy}} -->
              <div class="table-responsive table-wrapper">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <th class="text-center">Marketplace</th>
                      <th class="text-center">Brand &amp; Product</th>
                      <!-- <th class="text-center">Product</th> -->
                      <th class="text-center">
                        <a
                          class="link"
                          @click.prevent="sortByColumn('store_name')"
                        >
                          Username Toko
                          <span
                            v-if="sortBy != 'store_name'"
                            class="text-muted"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'store_name' && orderBy == 'asc'
                            "
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'store_name' && orderBy == 'desc'
                            "
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>

                        <!-- </div> -->
                      </th>
                      <th class="text-center">
                        <a
                          class="link"
                          @click.prevent="sortByColumn('product_name')"
                        >
                          Nama Produk
                          <span
                            v-if="sortBy != 'product_name'"
                            class="text-muted"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'product_name' && orderBy == 'asc'
                            "
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'product_name' && orderBy == 'desc'
                            "
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                      <th class="text-center">
                        <a
                          class="link"
                          @click.prevent="sortByColumn('product_price')"
                        >
                          Harga Produk
                          <span
                            v-if="sortBy != 'product_price'"
                            class="text-muted"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'product_price' && orderBy == 'asc'
                            "
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'product_price' && orderBy == 'desc'
                            "
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                      <!-- <th>Url</th> -->
                      <th class="text-center">Gambar Produk</th>
                      <th class="text-center">Screenshot</th>
                      <th class="text-center">Status</th>
                      <th class="text-center">
                        <a class="link" @click.prevent="sortByColumn('rating')">
                          Rating
                          <span v-if="sortBy != 'rating'" class="text-muted">
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'rating' && orderBy == 'asc'"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'rating' && orderBy == 'desc'"
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                      <th class="text-center">
                        <a class="link" @click.prevent="sortByColumn('rater')">
                          Penilaian
                          <span v-if="sortBy != 'rater'" class="text-muted">
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'rater' && orderBy == 'asc'"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'rater' && orderBy == 'desc'"
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                      <th class="text-center">
                        <a class="link" @click.prevent="sortByColumn('sales')">
                          Terjual
                          <span v-if="sortBy != 'sales'" class="text-muted">
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'sales' && orderBy == 'asc'"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="sortBy == 'sales' && orderBy == 'desc'"
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                      <th class="text-center">
                        <a
                          class="link"
                          @click.prevent="sortByColumn('update_datetime')"
                        >
                          Last Modified
                          <span v-if="sortBy == ''">
                            <i class="fa fa-long-arrow-up text-muted"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="sortBy != 'update_datetime'"
                            class="text-muted"
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'update_datetime' && orderBy == 'asc'
                            "
                          >
                            <i class="fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down text-muted"></i>
                          </span>
                          <span
                            v-else-if="
                              sortBy == 'update_datetime' && orderBy == 'desc'
                            "
                          >
                            <i class="text-muted fa fa-long-arrow-up"></i>
                            <i class="fa fa-long-arrow-down"></i>
                          </span>
                        </a>
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="7">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <td class="text-center text-wrap">
                          <div v-html="marketplaceIcon(row.mp_id)"></div>
                          <i
                            style="margin-top: 8px;"
                            v-if="row.is_bookmark == 1"
                            class="la la-bookmark"
                          ></i>
                        </td>
                        <td class="text-wrap">
                          <div class="text-muted" :ref="'brand-' + row.id">
                            <Skeleton :count="1" />
                          </div>
                          <div
                            class="text text-dark"
                            :ref="'product-' + row.id"
                          >
                            <Skeleton :count="1" />
                          </div>
                        </td>
                        <!-- <td class="text-wrap" :ref="'product-'+row.id">
                          <Skeleton :count="1" />
                        </td>-->
                        <td class="text-left">
                          <a
                            :href="row.store_link"
                            target="_blank"
                            v-if="row.store_name != ''"
                            >{{ row.store_name }}</a
                          >
                          <Skeleton
                            :count="1"
                            v-else-if="row.scraping_status == 1"
                          />
                          <i
                            class="text-warning"
                            v-if="row.scraping_status == 1"
                          >
                            <br />
                            scraping: {{ timeAgo(row.update_datetime) }}
                          </i>
                        </td>
                        <td class="text-wrap">
                          <a :href="row.product_url" target="_blank">
                            {{ row.product_name }}
                          </a>
                        </td>
                        <td class="text-right">
                          <span>
                            {{ formatPrice(row.product_price_start) }}
                          </span>
                          <span
                            v-if="
                              row.product_price_start < row.product_price_end
                            "
                            >- {{ formatPrice(row.product_price_end) }}</span
                          >
                        </td>
                        <!-- <td class="text-wrap">
                          <input type="text" :value="row.product_url" readonly style="border:0px;" />
                        </td>-->
                        <td class="text-wrap">
                          <span v-if="row.product_image != ''">
                            <a :href="row.product_image" target="_blank">
                              <img
                                style="width:100px;"
                                v-lazy="row.product_image"
                                alt
                                class="squared"
                              />
                            </a>
                          </span>
                        </td>
                        <td class="text-wrap">
                          <span v-if="row.scraping_file_screenshot != ''">
                            <a
                              :href="row.scraping_file_screenshot"
                              target="_blank"
                            >
                              <img
                                style="width:100px;"
                                v-lazy="row.scraping_file_screenshot"
                                alt
                                class="squared"
                              />
                            </a>
                          </span>
                        </td>
                        <td class="text-center">
                          <div
                            v-html="
                              monitoringStatusLabelStyle(row.status_value)
                            "
                          ></div>
                        </td>
                        <td class="text-center text-wrap">
                          <div v-if="Number(row.rating) > 0">
                            <StarRating
                              :rating="Number(row.rating)"
                              :read-only="true"
                              :increment="0.1"
                              :star-size="25"
                            />
                          </div>
                        </td>
                        <td class="text-right text-wrap">
                          <span v-if="Number(row.rater) > 0">{{
                            row.rater
                          }}</span>
                        </td>
                        <td class="text-right text-wrap">
                          <span v-if="Number(row.sales) > 0">{{
                            row.sales
                          }}</span>
                        </td>
                        <td class="text-wrap">
                          {{ formatLocalDate(row.update_datetime) }}
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="7" class="text-center">-empty-</td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <div class="row">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select
                @change="onPerPageChange(serverParams.perPage)"
                autocomplete="off"
                name="perPageSelect"
                v-model="serverParams.perPage"
                style="width: 100px;"
                class="select-to-paginasi"
              >
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label"
                >of {{ totalRecords }} total records</span
              >
            </div>
            <div class="col-sm-12 col-md-6 text-right">
              <a
                href="javascript:void(0)"
                @click="onPrevChange(parseInt(currentPage))"
                tabindex="0"
                class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }"
              >
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input
                style="width:100px;"
                min="1"
                type="number"
                v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))"
                class
              />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a
                href="javascript:void(0)"
                @click="onNextChange(parseInt(currentPage))"
                tabindex="0"
                class="footer__navigation__page-btn"
                :class="
                  'btn ' +
                    {
                      disabled:
                        parseInt(currentPage) + 1 >
                        Math.ceil(totalRecords / serverParams.perPage)
                    }
                "
              >
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <form-data ref="search" :searchData="searchDataMore" />

    <form-add :searchData="searchDataMore" />

    <form-edit :searchData="searchDataMore" />

    <form-import :searchData="searchDataMore" />
    <form-import-html :searchData="searchDataMore" />
  </div>
</template>

<script>
import { Skeleton } from "vue-loading-skeleton";
import StarRating from "vue-star-rating";
import {
  getFirstLastDayInWeek,
  formatDateForMessage,
  formatPrice,
  formatLocalDate,
  marketplaceIcon,
  monitoringStatusLabelStyle,
  monitoringStatusLabel,
  timeAgo
} from "@/utils/helper";
import FormData from "./form.vue";
import FormAdd from "./add.vue";
import FormEdit from "./edit.vue";
import FormImport from "./import.vue";
import FormImportHtml from "./importHtml.vue";

import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");
import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
import { aW } from "@fullcalendar/core/internal-common";
export default {
  components: {
    FormImportHtml,
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    FormData,
    FormAdd,
    FormEdit,
    FormImport,
    Multiselect,
    StarRating
  },
  data() {
    return {
      isKeywordId: false,
      isScheduleId: false,
      baseUrl: process.env.VUE_APP_BASE_URL,
      isSrDetailId: false,
      sortcol: {
        product_name: "",
        product_price: "",
        store_name: "",
        update_datetime: ""
      },
      sortBy: "",
      orderBy: "",
      limitScrape: 100,
      linkExcel: "",
      selectedTable: [],
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      contactOptions:[],
      selectedContact :[],
      serverParams: {
        columnFilters: {
          start_date: "",
          end_date: "",
          product_id: "",
          brand_id: "",
          mp_id: "",
          status_value: "",
          keywords_id: "",
          scraping_schedule_id: "",
          sr_detail_id: "",
          rating: "",
          is_store_name: "",
          store_name: "",
          product_name: "",
          product_url: "",
          product_price_start: "",
          product_price_end: ""
        },
        page: 1,
        perPage: 20, // perPage
        more_search: false,
        mpIds: [],
        sortBy: "",
        orderBy: ""
      }
    };
    //  isactive : true
  },
  computed: {
    formParamSt() {
      return this.$store.state.monitoring.formParamSt;
    },
    isShowForm() {
      return this.$store.state.monitoring.isShowForm;
    },
    selectAllTable: {
      get: function() {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function(value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function(row) {
            selectedTable.push(row.id);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact(val){
      if(val.length > 0){
        this.serverParams.columnFilters.brand_id = val[0].id
      }else{
        this.serverParams.columnFilters.brand_id = ""
      }
      this.$refs.search.selectedContact = val 
    }
  },
  async created() {
    let sr_detail_id = this.$route.query.sr_detail_id;
    this.isSrDetailId = false;
    if (typeof sr_detail_id != "undefined" && sr_detail_id != "") {
      // console.log("id", id);
      this.isSrDetailId = true;
      this.serverParams.columnFilters.sr_detail_id = await sr_detail_id;
    }
    let scraping_schedule_id = this.$route.query.scraping_schedule_id;
    this.isScheduleId = false;
    if (
      typeof scraping_schedule_id != "undefined" &&
      scraping_schedule_id != ""
    ) {
      // console.log("id", id);
      this.isScheduleId = true;
      this.serverParams.columnFilters.scraping_schedule_id = await scraping_schedule_id;
    }
    let keywords_id = this.$route.query.keywords_id;
    this.isKeywordId = false;
    if (typeof keywords_id != "undefined" && keywords_id != "") {
      // console.log("id", id);
      this.isKeywordId = true;
      this.serverParams.columnFilters.keywords_id = await keywords_id;
    }
    this.getFirstLastDayInWeek();
    this.asyncFind()
    this.loadItems();
    this.currentPage = this.serverParams.page;
  },
  methods: {
    asyncFind(query) {
      this.isLoading = true;
      let contactListParam =  {
        name: query,
        page: 0,
        perPage: 20
      }
      this.$store
        .dispatch('brand/listAgent',  contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
    },
    sortByColumn(column) {
      // console.log("column", column);
      const selected = column === Object.keys(this.sortcol)[0];
      // console.log("selected", selected);
      let sort = "";
      if (selected) {
        this.sortBy = column;
        this.orderBy = this.sortcol[column] === "asc" ? "desc" : "asc";
        this.sortcol[column] = this.orderBy;
        // console.log("this.sortcol[column]", this.sortcol[column]);
      } else {
        this.sortcol = {};
        this.orderBy = "asc";
        this.sortBy = column;
        this.sortcol[column] = this.orderBy;
      }

      this.serverParams.page = 1;
      this.serverParams.sortBy = this.sortBy;
      this.serverParams.orderBy = this.orderBy;
      this.loadItems();
      // this.currentSortCol = this.sortcol;
      // console.log("this.sortcol[column]", sort);

      // this.sortItems(column, Object.keys(this.sortcol))
    },
    timeAgo(unixTime) {
      return timeAgo(unixTime);
    },
    async scrapingDetailProduct() {
      this.isLoading = await true;
      // let success = await 0;
      // let failed = await 0;
      // let totalData = await 1;

      if (this.selectedTable.length > this.limitScrape) {
        this.$fire({
          title: "Limit Scrape",
          text:
            "Only allowed " +
            this.limitScrape +
            " data to be processed at this moment.",
          type: "warning",
          timer: 4000
        });
        this.isLoading = await false;

        return;
      }

      await this.selectedTable.forEach(async (monitoringId, idx) => {
        let newParam = {
          monitoringId: monitoringId
        };
        await this.$store.dispatch(
          "monitoring/scrapingDetailProduct",
          newParam
        );
        // .then(response => {
        //   success++;
        // })
        // .catch(e => {
        //   failed++;
        // });
        // totalData++;
      });
      await this.$fire({
        title: "In Progress",
        text: "The Scraping Process is on the way.",
        type: "success",
        timer: 4000
      });
      this.isLoading = await false;
      await this.hideActions();
      this.searchData();
    },
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionUpdateStatus(statusValue) {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to update status " +
          this.selectedTable.length +
          " items to " +
          this.monitoringStatusLabel(statusValue) +
          "?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "update_status",
              status: statusValue
            };
            this.$store
              .dispatch("monitoring/monitoringActionStore", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Update",
                  text: "The data was successfully updated",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable,
              action: "delete"
            };
            this.$store
              .dispatch("monitoring/duplicate", newParam)
              .then(_ => {
                this.$store
                  .dispatch("monitoring/monitoringActionStore", newParam)
                  .then(response => {
                    this.$fire({
                      title: "Success Delete",
                      text: "The data was successfully deleted",
                      type: "success",
                      timer: 2000
                    });
                    this.isLoading = false;
                    this.selectedTable = [];
                    this.selectAllTable = false;
                    this.searchData();
                  })
                  .catch(e => {
                    this.isLoading = false;
                  });
              })
              .catch(_ => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionBookmarks() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to bookmark " +
          this.selectedTable.length +
          " items?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              bookmarks: this.selectedTable
            };
            this.$store
              .dispatch("monitoring/bookmark", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Bookmark",
                  text: "The data was successfully bookmarked",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;
                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    monitoringStatusLabel(status) {
      return monitoringStatusLabel(status);
    },
    monitoringStatusLabelStyle(status) {
      return monitoringStatusLabelStyle(status);
    },
    formatDateForMessage(utcDateTime, format) {
      return formatDateForMessage(utcDateTime, format);
    },
    getFirstLastDayInWeek() {
      // let days = getFirstLastDayInWeek();
      // this.serverParams.columnFilters.start_date = this.formatDateForMessage(
      //   days.firstday,
      //   "ISODate"
      // );
      // this.serverParams.columnFilters.end_date = this.formatDateForMessage(
      //   days.lastday,
      //   "ISODate"
      // );
    },
    showSearchForm() {
      this.$store.dispatch("monitoring/setIsShowForm", false);
      this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      this.$refs.search.selectedContact = this.selectedContact;
      var that = this; 
      setTimeout(function() {
        var liContainer = document.getElementById("search_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowForm", true);
        }
      }, 1000);
    },
    showSearchFormAdd() {
      this.$store.dispatch("monitoring/setIsShowFormAdd", false);
      // this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("add_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowFormAdd", true);
        }
      }, 1000);
    },
    showSearchFormImport() {
      this.$store.dispatch("monitoring/setIsShowFormImport", false);
      // this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("import_form");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowFormImport", true);
        }
      }, 1000);
    },
    showFormImportHtml() {
      this.$store.dispatch("monitoring/setIsShowFormImportHtml", false);
      // this.$store.dispatch("monitoring/actFormParamSt", this.serverParams);
      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("import_form_html");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowFormImportHtml", true);
        }
      }, 1000);
    },
    async actionEdit(id) {
      // if (this.selectedTable.length > 1) {
      //   this.$fire({
      //     title: "Error",
      //     text: "Edit hanya bisa dilakukan 1 link.",
      //     type: "error",
      //     timer: 2000
      //   });
      //   return;
      // }

      this.$store.dispatch("monitoring/setIsShowFormEdit", false);

      this.$store.dispatch("monitoring/setIsShowFormEditId", id);

      var that = this;
      setTimeout(function() {
        var liContainer = document.getElementById("edit_form");
        var isShowModal = liContainer.classList.contains("show");

        if (isShowModal == true) {
          that.$store.dispatch("monitoring/setIsShowFormEdit", true);
        }
      }, 1000);
    },

    marketplaceIcon(value) {
      return marketplaceIcon(value);
    },
    formatLocalDate(unixTime) {
      return formatLocalDate(unixTime);
    },
    formatPrice(number) {
      return formatPrice(number);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },

    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.selectedContact = this.$refs.search.selectedContact;
      this.linkExcel = "";
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      await this.$store.dispatch(
        "monitoring/actFormParamSt",
        this.serverParams
      );
    },
    async searchDataMore() {
      this.linkExcel = "";
      this.selectedContact = this.$refs.search.selectedContact;
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();
      this.serverParams = this.formParamSt;
      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;

      // await this.$store.dispatch(
      //   "monitoring/actFormParamSt",
      //   this.serverParams
      // );
    },
    async exportExcel(versi) {
      this.linkExcel = "";

      let newParam = this.formParamSt;
      this.isLoading = await true;
      // var newParam = this.serverParams;
      delete newParam.page;
      delete newParam.perPage;

      if (versi == "full") {
        await this.loadItemsExportExcel(newParam);
      } else if (versi == "mp") {
        await this.loadItemsExportExcelMP(newParam);
      } else if (versi == "pdf") {
        await this.loadItemsExportPDFMP(newParam);
      }

      this.isLoading = await false;
    },
    async loadItemsExportExcel(newParam) {
      this.isLoading = await true;

      await this.$store
        .dispatch("monitoring/agentListLinkExcel", newParam) // sesuai kan dengan method di API
        .then(response => {
          // const { data } = response;
          this.linkExcel = response.data.url;
          window.open(this.linkExcel, "_blank"); // Opens a new tab

          // console.log(response);
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    async loadItemsExportExcelMP(newParam) {
      this.isLoading = await true;

      await this.$store
        .dispatch("monitoring/agentListLinkExcelMP", newParam) // sesuai kan dengan method di API
        .then(response => {
          // const { data } = response;
          this.linkExcel = response.data.url;
          window.open(this.linkExcel, "_blank"); // Opens a new tab

          // console.log(response);
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    async loadItemsExportPDFMP(newParam) {
      this.isLoading = await true;

      await this.$store
        .dispatch("monitoring/agentListLinkPDFMP", newParam) // sesuai kan dengan method di API
        .then(response => {
          // const { data } = response;
          this.linkExcel = response.data.url;
          window.open(this.linkExcel, "_blank"); // Opens a new tab

          // console.log(response);
          this.isLoading = false;
        })
        .catch(error => {
          console.log(error);
          this.isLoading = false;
        });
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);
      // if (!this.serverParams.columnFilters.brand_id) {
      //   this.$fire({
      //     title: "Error",
      //     text: "Isi brand terlebih dahulu.",
      //     type: "error",
      //     timer: 2000
      //   });
      //   return;
      // }
      await this.$store
        .dispatch("monitoring/agentListLink", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = Number(data.totalRecords);
          this.rowPage = data.page;
          this.rows = data.data; 
          // console.log("rows", this.rows);
          this.loading = false;

          if (this.rows.length) {
            this.rows.forEach((row, idx) => {
              let detailId = row.brand_id;
              this.$store
                .dispatch("brand/detail", detailId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["brand-" + row.id][0].innerHTML = resData.name;
                });
              let prodId = row.product_id;

              this.$store
                .dispatch("brandProduct/detail", prodId) // sesuai kan dengan method di API
                .then(responseDet => {
                  var resData = responseDet.data;
                  this.$refs["product-" + row.id][0].innerHTML = resData.name;
                });
            });
          }
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function(e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>

<style>
.table-wrapper {
  max-height: calc(100vh - 140px);
  position: relative;
}

.table-wrapper table {
  border-collapse: collapse !important;
}

.table-wrapper table th {
  position: sticky !important;
  background: white;
  top: -1px;
}

.text-blue {
  color: #1890ff !important;
}
</style>



// WEBPACK FOOTER //
// src/views/monitoring/links/listAgent.vue